import type { Observable } from 'rxjs';

import { createProviderClass } from '@core/common-legacy';
// eslint-disable-next-line boundaries/element-types
import type { SupportedThemesT, Theme, ThemeName } from '@core/theme-util'; // --FIXME

export abstract class CurrentUserPreferencesContract {
  public abstract activeTheme$: Observable<Theme>;
  public abstract activeThemeName$: Observable<ThemeName>;
  public abstract effectiveThemeName$: Observable<SupportedThemesT>;
  public abstract pipelinePromoteBannerDismissedOfferIds$: Observable<number[]>;

  public abstract setActiveTheme(themeName: ThemeName): void;
  public abstract setPipelinePromoteBannerDismissedOfferIds(offerIds: number[]): void;
}

export const {
  inject: injectCurrentUserPreferencesContract,
  provide: provideCurrentUserPreferencesContract,
} = createProviderClass(CurrentUserPreferencesContract)();
